import UpdatePathologyForm from 'components/form/super-admin/pathology/UpdatePathologyForm'
import React, { Component } from 'react'
import { Col, Container, Row } from 'reactstrap'

export default class UpdatePathology extends Component {
    render() {
        return (
            <>
                <div className="page-content">
                    <Container fluid>
                        <Row>
                            <Col xl='12'>
                                <h4 className="mb-0 font-size-18"> Update Pathology</h4>
                                <UpdatePathologyForm />
                            </Col>
                        </Row>
                    </Container>
                </div>
            </>
        )
    }
}
